<template>
  <UButton
    class="flex md:inline-flex justify-center md:ml-auto bg-cardinal dark:bg-cardinal dark:text-white btn-64-legend"
    size="xl"
  >
    <i class="fas fa-key text-sm"></i>
    <span class="hidden md:inline text-sm">View Legend</span>
  </UButton>
</template>
